'use client'

import { useState, useEffect } from 'react'
import { CampaignPopup } from '@definitions/types/storyblokTypes'
import { fetchCampaignPopup } from '@api/storyblok/rest/fetchCampaignPopup'

/**
 * Hook to fetch campaign popup for a given brand
 * @param brand - The brand to fetch campaign popup for
 * @returns CampaignPopup or null
 */
export function useCampaignPopup(
  brand: 'sunpoint' | 'wellmaxx' | undefined
): CampaignPopup | null {
  const [campaignPopup, setCampaignPopup] = useState<CampaignPopup | null>(null)

  useEffect(() => {
    if (!brand) {
      return
    }

    fetchCampaignPopup(brand)
      .then(setCampaignPopup)
      .catch(() => {
        // Errors are handled in fetchCampaignPopup, just set to null on failure
        setCampaignPopup(null)
      })
  }, [brand])

  return campaignPopup
}
